import { GuacModeLinkClickEvent } from '@/services/analytics/events/guac-mode-link-click';
import { GuacModeLinkClickType, LinkClickElementType } from '@/services/analytics/platforms/adobe-analytics/models';
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';

@Component({
  name: 'CmgGuacModeVerifiedModal',
})
export default class CmgGuacModeVerifiedModal extends Vue {
  get visible(): boolean {
    return this.$appStore.state.ui.modals.guacModeVerified.visible;
  }

  get isGuacMode(): boolean {
    return this.$appStore.getters.isCustomerGuacMode
  }

  get guacModePepperImageUrl(): string {
    return this.$appStore.state.cms.images.icons.guacModePepperBadge.default;
  }

  get guacModePepperSparkleImageUrl(): string {
    return this.$appStore.state.cms.images.icons.guacModePepperBadgeSparkle.default;
  }

  get headerImage(): string {
    return this.isGuacMode ? '' : this.guacModePepperImageUrl;
  }

  get titleText(): string {
    return `${this.isGuacMode ? `YOU'RE` : 'GET'} GUAC MODE VERIFIED`;
  }

  @Watch('visible', { immediate: true })
  async visibleChanged(visible: boolean) {
    if (visible) {
      Vue.nextTick(() => {
        setTimeout(() => (this.$refs.mainTitle as HTMLElement).focus(), 500);
      });
    }
  }

  onClickVerifyMe(): void {
    // TODO: handle when user clicks 'verify me'
  }

  onClickHowGuacModeWorks(): void {
    // TODO: handle when user clicks 'how guac mode works'
  }

  onClickLearnMore(): void {
    this.$services.analytics.send(new GuacModeLinkClickEvent(GuacModeLinkClickType.LearnMore, LinkClickElementType.Link));
  }

  close() {
    this.$services.ui.setModalVisibility('guacModeVerified', false);
    Vue.nextTick(() => {
      setTimeout(() => {
        this.$services.ui.focusBack();
      }, 1000);
    });
  }
}
